/*
 * localization-deferred.js
 *
 * The country/currency picker used to render its full ~237-country list inline in
 * all three <localization-form> instances (desktop header, mobile header, footer),
 * putting ~717 dead <a href="#"> anchors into the live DOM on every page load.
 *
 * snippets/country-options-template.liquid now renders that list ONCE per page
 * (from layout/theme.liquid) into an inert <template id="CountryOptionsTemplate">.
 * This script clones it into whichever picker the shopper actually opens, on the
 * first interaction with that picker, and wires up the same submit behaviour that
 * assets/localization-form.js applies to inline options.
 *
 * Country/currency switching is functionally unchanged.
 */
(function () {
  'use strict';

  var TEMPLATE_ID = 'CountryOptionsTemplate';

  function onItemClick(event) {
    event.preventDefault();

    var link = event.currentTarget;
    var root = link.closest('localization-form');
    if (!root || root.dataset.localizationSubmitting === 'true') return;

    var input = root.querySelector('input[name="country_code"], input[name="locale_code"]');
    var form = root.querySelector('form') || root.closest('form');
    if (!input || !form) return;

    root.dataset.localizationSubmitting = 'true';
    input.value = link.dataset.value;
    form.submit();
  }

  function hydrate(root) {
    if (!root || root.dataset.countryOptionsReady === 'true') return;

    var list = root.querySelector('.country-selector__list');
    var template = document.getElementById(TEMPLATE_ID);
    if (!list || !template || !template.content) return;

    root.dataset.countryOptionsReady = 'true';
    list.appendChild(template.content.cloneNode(true));

    // Options are cloned into up to three pickers, so give each clone an id that
    // is unique per picker. localization-form.js points aria-activedescendant at it.
    var prefix = list.id || 'country';

    Array.prototype.forEach.call(list.querySelectorAll('a[data-value]'), function (link) {
      link.id = prefix + '-' + link.dataset.value;
      link.addEventListener('click', onItemClick);
    });
  }

  function onInteract(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var root = target.closest('localization-form');
    if (root) hydrate(root);
  }

  // Capture phase so the list exists before localization-form.js opens the panel.
  ['click', 'keydown', 'keyup', 'focusin'].forEach(function (type) {
    document.addEventListener(type, onInteract, true);
  });
})();
